import { Contact } from './Contact';

export function Customer() {
	this.discountPerCent = 0;
	this.invoiceContact = new Contact();
	this.deliveryContact = null;
	this.sendNews = false;
	this.remarks = '';
}